import React from 'react';
import { bool } from 'prop-types';
import classNames from 'classnames';
import { Counter } from '@fiverr-private/fit';
import { MAX_LENGTH } from '../../../constants';
import { useMessage } from '../../../context/contexts/message';
import ValidationMessage from './ValidationMessage';

import classes from './style.module.scss';

const TextareaFooter = ({ drawerView }) => {
    const { message } = useMessage();

    const wrapperClasses = classNames(
        'flex',
        'flex-between',
        'tbody-6',
        { 'm-t-8 p-l-24 p-r-24 p-b-12' : !drawerView },
        { 'p-t-8 p-b-8 m-r-32 m-l-32' : drawerView },
    );

    return (
        <footer className={wrapperClasses}>
            <ValidationMessage/>
            <section className={classes.counterContainer}>
                <Counter className={classNames(classes.counter)}
                    current={message.length}
                    max={MAX_LENGTH}/>
            </section>
        </footer>
    );
};

TextareaFooter.propTypes = {
    drawerView: bool
};

export default TextareaFooter;
